import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function TennisNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Tennis",
    links: [
      {href: "/tennis", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

TennisNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default TennisNav



// WEBPACK FOOTER //
// ./modules/Tennis/nav/TennisNav.js